export type JssdkContextStatus =
  | "not_in_wecom"
  | "jssdk_not_started"
  | "jssdk_initializing"
  | "jssdk_blocked"
  | "no_customer_context"
  | "permission_denied"
  | "api_not_supported"
  | "signature_error"
  | "unknown_get_external_contact_error"
  | "customer_identified";

export function getJssdkContextMessage(status: JssdkContextStatus, blockedIp: string | null = null): string {
  switch (status) {
    case "not_in_wecom":
      return "当前不是企业微信浏览器，不能判断客户聊天上下文。";
    case "jssdk_not_started":
      return "JS-SDK 尚未初始化，暂时无法判断客户聊天上下文。";
    case "jssdk_initializing":
      return "正在获取签名并初始化 JS-SDK。";
    case "jssdk_blocked":
      return blockedIp
        ? `企业微信接口拒绝了当前服务器 IP。请将服务器出口 IP ${blockedIp} 配置到对应的企业可信 IP 或可信来源 IP。`
        : "JS-SDK 初始化被企业微信 API 错误阻断。";
    case "no_customer_context":
      return "企业微信没有向当前网页提供外部联系人上下文。请确认页面确实从外部联系人单聊工具栏打开。";
    case "permission_denied":
      return "当前自建应用或当前成员缺少客户联系相关权限。";
    case "api_not_supported":
      return "当前企业微信客户端或 SDK 环境不支持该接口，请检查客户端和 @wecom/jssdk 版本。";
    case "signature_error":
      return "getCurExternalContact 签名校验失败，请检查 URL 签名和 JS-SDK 注册状态。";
    case "unknown_get_external_contact_error":
      return "getCurExternalContact 调用失败，但当前返回信息不足以判断具体原因。";
    case "customer_identified":
      return "已通过 getCurExternalContact 获取 external_userid。";
  }
}

export function isNormalWorkbenchNoCustomerContext(status: JssdkContextStatus): boolean {
  return status === "no_customer_context";
}
